/* Moves the shortlist control on product tiles from the top-right image icon
   to a labelled button under the price. Runs after bigsmall-shortlist-v3.js has
   injected the control, so the add/remove logic in v3 is untouched. */
(function () {
  'use strict';

  function place() {
    document.querySelectorAll('.bs-shortlist-card-control').forEach(function (holder) {
      var wrapper = holder.closest('.product-card-wrapper, .card-wrapper');
      if (!wrapper) return;
      var anchor = wrapper.querySelector('.card-information') || wrapper.querySelector('.card__information');
      if (!anchor) return;
      holder.className = 'bs-shortlist-card-cta';
      anchor.insertAdjacentElement('afterend', holder);
    });
  }

  function start() {
    place();
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) { place(); return; }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
